
export const env = window.__env__ || {};
env.VUE_APP_API_URL = env.VUE_APP_API_URL || process.env.VUE_APP_API_URL;
env.VUE_APP_UPLOAD_URL = env.VUE_APP_UPLOAD_URL || process.env.VUE_APP_UPLOAD_URL;
env.VUE_APP_ASSETS_BUCKET = env.VUE_APP_ASSETS_BUCKET || process.env.VUE_APP_ASSETS_BUCKET;
env.VUE_APP_QUESTIONS_ENDPOINT = env.VUE_APP_QUESTIONS_ENDPOINT || process.env.VUE_APP_QUESTIONS_ENDPOINT;
env.VUE_APP_CATALOGS_ENDPOINT = env.VUE_APP_CATALOGS_ENDPOINT || process.env.VUE_APP_CATALOGS_ENDPOINT;
env.VUE_APP_ACCOUNTS_URL = env.VUE_APP_ACCOUNTS_URL || process.env.VUE_APP_ACCOUNTS_URL;
env.VUE_APP_GROUP_TEACHER_ID = env.VUE_APP_GROUP_TEACHER_ID || process.env.VUE_APP_GROUP_TEACHER_ID;
env.VUE_APP_GROUP_OPERATOR_ID = env.VUE_APP_GROUP_OPERATOR_ID || process.env.VUE_APP_GROUP_OPERATOR_ID;
env.VUE_APP_GROUP_ADMIN_ID = env.VUE_APP_GROUP_ADMIN_ID || process.env.VUE_APP_GROUP_ADMIN_ID;
env.VUE_APP_ENV = env.VUE_APP_ENV || process.env.VUE_APP_ENV;

export const envPlugin = {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$env', {
      get: () => env,
      set() {
        throw new Error('You can\'t set $env');
      },
    });
  },
};
